import { useState, useEffect, useCallback } from 'react';
import { useApi } from './useApi';

export function useBilling() {
  const { authFetch } = useApi();
  const [billing, setBilling] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStatus = useCallback(async () => {
    try {
      const data = await authFetch('/api/billing/status');
      setBilling(data);
    } catch (err) {
      // Default to free tier on error — never block the UI
      setBilling({
        tier: 'free',
        features: { benchmark: false, csv_export: false, ab_comparison: false },
        usage: {
          simulations_used: 0, simulations_limit: 50, simulations_pct: 0,
          tickets_imported: 0, tickets_limit: 100, tickets_pct: 0,
        },
      });
    } finally {
      setLoading(false);
    }
  }, [authFetch]);

  useEffect(() => { fetchStatus(); }, [fetchStatus]);

  const checkout = async (tier) => {
    try {
      const data = await authFetch('/api/billing/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tier }),
      });
      window.location.href = data.url;
    } catch (err) {
      console.error('Checkout failed:', err);
    }
  };

  const openPortal = async () => {
    try {
      const data = await authFetch('/api/billing/portal', { method: 'POST' });
      window.location.href = data.url;
    } catch (err) {
      console.error('Portal failed:', err);
    }
  };

  return { billing, loading, checkout, openPortal, refetch: fetchStatus };
}